import PaginationState from './PaginationState'
import Page from './Page'

import { Client as RevasClient } from '@revas/ts-api'

import Metadata, { Resource, Contact } from '@/models'
import { createUtcIsoDate, substractDays } from '@/store/helper'

export class ResourceContact {
  id = ''
  contactId = ''
  name = ''
  email = ''
  phone = ''
  effectiveFrom = ''
  effectiveTo = ''
}

export default class ListResourcesPagination extends PaginationState<ResourceContact> {
  revasClient: RevasClient | null = null

  constructor (revasClient: RevasClient, pageSize: number, search: string) {
    super(pageSize, search)
    this.revasClient = revasClient
  }

  async asyncRequestPage (token: string): Promise<[Page<ResourceContact>, string]> {
    if (this.revasClient === null) {
      throw new Error('client is null')
    }

    const resourcesResponse = await this.revasClient.asyncRevasPost('/humans/humans.ListResources/', {
      pageSize: this.pageSize,
      pageToken: token,
      search: this.search
    })

    const resources: Resource[] = resourcesResponse.resources
    if (resources.length === 0) {
      return [new Page<ResourceContact>(), '']
    } else {
      let resourceContacts: ResourceContact[] = []
      resourceContacts = resources.map((r: Resource) => {
        if (r.metadata !== undefined) {
          const name: Metadata | undefined = r.metadata.find((m: Metadata) => {
            return m.key === 'contacts.contact.name'
          })
          const email: Metadata | undefined = r.metadata.find((m: Metadata) => {
            return m.key === 'contacts.contact.email'
          })
          const phone: Metadata | undefined = r.metadata.find((m: Metadata) => {
            return m.key === 'contacts.contact.phone'
          })
          const formattedResource: ResourceContact = {
            id: r.id,
            contactId: r.contactId,
            name: name === undefined ? '' : name.value,
            email: email === undefined ? '' : email.value,
            phone: phone === undefined ? '' : phone.value,
            effectiveFrom: r.effectiveFrom,
            effectiveTo: createUtcIsoDate(substractDays(new Date(r.effectiveTo), 1))
          }
          return formattedResource
        } else {
          const formattedResource: ResourceContact = {
            id: r.id,
            contactId: r.contactId,
            name: '',
            email: '',
            phone: '',
            effectiveFrom: r.effectiveFrom,
            effectiveTo: createUtcIsoDate(substractDays(new Date(r.effectiveTo), 1))
          }
          return formattedResource
        }
      })
      const newPage = new Page<ResourceContact>()
      newPage.items = resourceContacts
      return [newPage, resourcesResponse.nextPageToken]
    }
  }

  clone (): PaginationState<ResourceContact> {
    if (this.revasClient === null) {
      throw new Error('revas client is null')
    }
    const p = new ListResourcesPagination(this.revasClient, this.pageSize, this.search)
    p.tokens = this.tokens
    p.currentPage = this.currentPage
    return p
  }
}
